import React, { Component } from "react";

// CSS
import "../../../../css/forms/reviewer-registration-item.css";

class RegisteredReviewerItem extends Component {
	render() {
		const { reviewer, buttons } = this.props;

		return (
			<div className="reviewer-registration-item">
				<div className="reviewer-registration-item--reviewer">
					<div className="reviewer-item--name">
						{`${reviewer.fname} ${reviewer.lname}`}
					</div>
					<div className="reviewer-item--email">
						<a
							href={`mailto:${reviewer.email}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							{`${reviewer.email}`}
						</a>
					</div>
					<div className="reviewer-item--phone">
						{`${reviewer.phone}`}
						{reviewer.phone_extension && ` Ext: ${reviewer.phone_extension}`}
					</div>
					{reviewer.phone_alternate_extension && (
						<div className="reviewer-item--phone">
							{`${reviewer.phone_alternate}`}
							{reviewer.phone_alternate_extension &&
								` Ext: ${reviewer.phone_alternate_extension}`}
						</div>
					)}
				</div>
				{!!buttons && (
					<div className="reviewer-registration-item--button">
						{buttons.map(btn => btn)}
					</div>
				)}
			</div>
		);
	}
}

export default RegisteredReviewerItem;



// WEBPACK FOOTER //
// ./src/components/admin/reviews/form-components/RegisteredReviewerItem.js